package ui.external.materialui

object Breakpoint {
    const val lg = "lg"
}
